export default __webpack_public_path__ + "featured-base-layer-light.db2bc01e.svg";